module.exports = __webpack_public_path__ + "img/Asessments.4b36647e.png";